import {Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {ChatService} from "./service/chat.service";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthControllerService, Project} from "../../api";
import {ChatTopNavComponent} from './chat-top-nav/chat-top-nav.component';
import {NgClass} from '@angular/common';
import {ChatViewComponent} from './chat-view/chat-view.component';
import {AllChatsViewComponent} from './all-chats-view/all-chats-view.component';
import {AllFilesViewComponent} from './all-files-view/all-files-view.component';
import {MessageViewComponent} from './message-view/message-view.component';
import {StateConfigService} from '../../services/state/state-config.service';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-chatBIC',
  templateUrl: './chatBIC.component.html',
  styleUrls: ['./chatBIC.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ChatTopNavComponent, NgClass, ChatViewComponent, AllChatsViewComponent, AllFilesViewComponent, MessageViewComponent]
})
export class ChatBICComponent implements OnInit, OnDestroy {
  protected chatService = inject(ChatService);

  /** Beide Flächen hier sind der klassische Chat – die myCheck-Fläche ist eingebettet. */
  protected get session() {
    return this.chatService.session('classic');
  }
  private activated = inject(ActivatedRoute);
  private authControllerService = inject(AuthControllerService);
  private stateConfigService = inject(StateConfigService);
  private router = inject(Router);
  private projectChangeSub?: Subscription;


  unloadHandler = (event: Event) => {
    this.chatService.stopListeningForNotifications()
    window.removeEventListener('beforeunload', this.unloadHandler)
  };

  ngOnInit() {
    // Close floating panel when navigating to the full chat page
    this.chatService.floatingChatOpen = false;
    this.chatService.isFloatingMode = false;
    // Die Chat-Seite ist die klassische Oberfläche; eine laufende myCheck-Fläche bleibt unberührt.
    this.chatService.activeSurface = 'classic';
    this.chatService.chatIdFromRouting = this.activated.snapshot.params.chatId
    this.chatService.resetChatState('classic')
    // Allow re-init for full page (e.g. loading a specific chatId from routing)
    this.chatService.isInitialized = false;
    this.chatService.initializeChat()
    window.addEventListener('beforeunload', this.unloadHandler)

    // Reset chat state when the project changes
    this.projectChangeSub = this.stateConfigService.projectChange.subscribe((project: Project) => {
      if (project?.id && project.id !== this.chatService.currentProject) {
        this.chatService.handleProjectChange(project.id);
        this.router.navigate(['projects', project.id, 'chat']);
      }
    });
  }

  ngOnDestroy(){
    this.chatService.stopListeningForNotifications()
    // Reset so FAB or next page visit can re-initialize
    this.chatService.isInitialized = false;
    this.projectChangeSub?.unsubscribe();
    window.removeEventListener('beforeunload', this.unloadHandler)
  }

}
